module.exports = __webpack_public_path__ + "img/down-arrow-swirl-green.50594f96.svg";